import { SoftwareFeaturePage } from './SoftwareFeaturePage';

export function WorkflowEnginePage() {
  return (
    <SoftwareFeaturePage content={{
      eyebrow: 'Software — Visual Workflow Engine',
      title: 'Automate the repetitive. Focus on the human.',
      subtitle: 'Drag-and-drop recruitment workflow automation — no code required.',
      description: 'Build rules that move candidates, trigger emails, assign reviewers, and escalate stalled stages automatically — so your team spends its time on conversations, not admin.',
      heroBg: 'linear-gradient(150deg, #FFFBEB 0%, #FEF3C7 35%, #FFFBEB 65%, #FEF9C3 100%)',
      accentText: 'text-amber-600',
      stats: [
        { value: 'Visual', label: 'Canvas — no code' },
        { value: '20+', label: 'Trigger & action types' },
        { value: 'Real-time', label: 'Execution & logging' },
        { value: '60%', label: 'Reduction in manual tasks' },
      ],
      sections: [
        {
          heading: 'Building Workflows',
          bullets: [
            'Drag-and-drop canvas with condition, trigger, and action nodes',
            'Triggers: stage change, score threshold, time elapsed, tag added',
            'Actions: move stage, send email, assign recruiter, post Slack message',
            'Branch logic — different paths for different candidate outcomes',
            'Template library for common recruiting scenarios',
            'Version history — roll back any workflow change',
          ],
        },
        {
          heading: 'Automation Scenarios',
          bullets: [
            'Auto-advance candidates who pass AI interview above threshold',
            'Send rejection email after 7 days of no activity in stage',
            'Notify hiring manager when shortlist reaches 5 candidates',
            'Create calendar event when interview stage is entered',
            'Post to Slack when offer is accepted',
            'Archive duplicates automatically on application receipt',
          ],
        },
        {
          heading: 'Monitoring',
          bullets: [
            'Live workflow run log — see every execution in real time',
            'Error alerts when a step fails with actionable reason',
            'Per-workflow performance stats — runs, successes, failures',
            'Pause, edit, and resume live workflows without data loss',
          ],
        },
      ],
    }} />
  );
}
